<template>
  <div>
    <Error
      v-if="!loadingCampaigns && errors.length"
      message="It looks like we couldn't fetch your campaigns right now."
      :errors="errors"
      :error-action="refetchCampaigns"
      error-action-label="Retry?"
      class="error"
    />

    <CampaignListFilters
      :disabled="loadingCampaigns"
      :status="status"
      @filter-selected="refetchCampaigns"
    />

    <div>
      <ZoomCenterTransition v-if="campaigns.length" group>
        <CampaignListItem
          v-for="campaign in campaigns"
          :key="campaign.campaignId"
          :campaign="campaign"
          :reloading="reloading"
          @refetch-campaigns="refetchCampaigns"
          @remove-campaign="refetchCampaigns"
        />
      </ZoomCenterTransition>

      <Loader
        v-if="loadingCampaigns || reloading"
        label="Loading Campaigns..."
      />

      <Button
        v-if="canLoadMore && !loadingCampaigns && campaigns.length"
        class="secondary xs mx-auto"
        @click="loadMore"
        >Load More</Button
      >
    </div>

    <CampaignListEmpty
      v-if="!loadingCampaigns && !reloading && !campaigns.length"
      :status="status"
    />
  </div>
</template>

<script>
import { ZoomCenterTransition } from "vue2-transitions";
import Loader from "@/components/UI/Loader";
import Error from "@/components/UI/Error";
import CampaignListItem from "./CampaignListItem";
import CampaignListFilters from "./CampaignListFilters";
import CampaignListEmpty from "./CampaignListEmpty";

export default {
  name: "CampaignList",
  components: {
    CampaignListEmpty,
    CampaignListFilters,
    CampaignListItem,
    Error,
    ZoomCenterTransition,
    Loader,
  },
  props: {
    canLoadMore: {
      type: Boolean,
      default: false,
    },
    campaigns: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
      default: () => [],
    },
    loadingCampaigns: {
      type: Boolean,
      default: false,
    },
    loadMore: {
      type: Function,
      default: () => {},
    },
    refetchCampaigns: {
      type: Function,
      default: () => {},
    },
    reloading: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.error {
  @apply mb-8 max-w-md mx-auto;
}
</style>
